import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtMoney } from "@/lib/pharmacy";

const Stat = ({ label, value, tone }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`stat-${label.toLowerCase().replace(/ /g,"-")}`}>
    <div className="text-xs font-bold uppercase text-slate-500">{label}</div>
    <div className={`font-display text-3xl font-bold mt-1 ${tone || "text-slate-900"} font-mono`}>{value}</div>
  </div>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-slate-500">Loading...</div>;
  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-slate-900">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <Stat label="Revenue" value={fmtMoney(s.revenue)} tone="text-emerald-700"/>
        <Stat label="Total orders" value={s.total_orders}/>
        <Stat label="Customers" value={s.total_customers}/>
        <Stat label="Products" value={s.total_products}/>
        <Stat label="Pending" value={s.pending} tone="text-amber-700"/>
        <Stat label="Processing" value={s.processing} tone="text-blue-700"/>
        <Stat label="Shipped" value={s.shipped} tone="text-sky-700"/>
        <Stat label="Delivered" value={s.delivered} tone="text-emerald-700"/>
      </div>
      <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6">
        <div className="text-xs font-bold uppercase text-slate-500">Total pills shipped</div>
        <div className="font-display text-4xl font-bold font-mono text-slate-900 mt-1">{s.total_pills_shipped.toLocaleString()}</div>
      </div>
    </div>
  );
}
